import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="px-4 md:px-8 lg:px-12 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 max-w-7xl mx-auto">
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-wider mb-5">资源下载</h4>
            <ul className="space-y-3">
              <li><Link to="/support/downloads" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">全系列产品白皮书</Link></li>
              <li><Link to="/support/downloads" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">硬件与说明书</Link></li>
              <li><Link to="/support/downloads" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">桌面客户端安装包</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-wider mb-5">产品中心</h4>
            <ul className="space-y-3">
              <li><Link to="/mossteams/dual-screen" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">MossTeams 会议同传</Link></li>
              <li><Link to="/mosstalk/standard" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">MossTalk 随身翻译</Link></li>
              <li><Link to="/mossvox/subtitle-pro" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">MossVox 智能字幕</Link></li>
              <li><Link to="/more-products/all-in-one" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">更多产品</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-wider mb-5">服务支持</h4>
            <ul className="space-y-3">
              <li><Link to="/support/cases" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">客户案例</Link></li>
              <li><Link to="/support/downloads" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">资源下载</Link></li>
              <li><a href="https://www.newtranx.com/contact" target="_blank" rel="nofollow noopener" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">企业官网</a></li>
              <li><Link to="/contact" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">商务合作</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-wider mb-5">联系我们</h4>
            <ul className="space-y-3">
              <li className="text-sm text-white/70 leading-relaxed">
                北京市通州区世界侨商中心2号楼17层
              </li>
              <li>
                <a href="tel:400-097-5066" className="text-sm text-white/85 hover:text-white transition-colors cursor-pointer font-medium">
                  <i className="ri-phone-line mr-1.5"></i>400-097-5066
                </a>
              </li>
              <li>
                <a href="mailto:service02@newtranx.com" className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line mr-1.5"></i>service02@newtranx.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* 关注我们 */}
      <div className="px-4 md:px-8 lg:px-12 pb-14 md:pb-18">
        <div className="max-w-7xl mx-auto">
          <h4 className="text-lg md:text-xl font-bold text-white text-center mb-8">关注我们</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6 max-w-4xl mx-auto">
            {[
              { name: '微信公众号', desc: '扫码关注最新资讯', src: '/images/qrcode/wechatPubQR.png' },
              { name: '微信视频号', desc: '扫码观看产品演示', src: '/images/qrcode/shipinhao.png' },
              { name: '抖音号', desc: '扫码查看精彩短视频', src: '/images/qrcode/douyin.png' },
              { name: '小红书号', desc: '扫码发现更多内容', src: '/images/qrcode/xiaohongshu.jpg' },
            ].map((item) => (
              <div key={item.name} className="bg-white/5 rounded-2xl p-5 flex flex-col items-center text-center">
                <div className="w-full aspect-square bg-white rounded-xl flex items-center justify-center overflow-hidden">
                  {item.src ? (
                    <img src={item.src} alt={item.name} className="w-full h-full object-contain" />
                  ) : (
                    <i className="ri-qr-code-line text-5xl text-foreground-300"></i>
                  )}
                </div>
                <div className="mt-4 text-sm font-semibold text-white">{item.name}</div>
                <div className="mt-1 text-xs text-white/50">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-4 md:px-8 lg:px-12 py-6 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-md flex items-center justify-center">
              <img src="/images/logo.png" alt="Logo" className="w-full h-full object-contain" />
            </div>
            <span className="text-sm text-white/50 xykj-no-translate ">新译科技硬件事业部</span>
          </div>
          <div className="xykj-no-translate flex items-center gap-6 text-sm text-white/40">
            <span>京ICP备18013632号-5</span>
            <span>&copy; 2026 NEWTRANX</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;